module.exports = __webpack_public_path__ + "4985c878ba9bfe8a59155daf1b60858e.jpg";